// import React, { useRef, useEffect, useState, useLayoutEffect } from 'react'
import React, { useState, useEffect } from 'react'
import * as NavStyles from './Nav.module.scss'
import { headerEvents } from '../../../lib/utils'
import Social from '../../Social/Social'

// Eat
// Travel
// Lifestyle
// Home

function getSubdomain(urlString: string) {
  try {
    const url = new URL(urlString)
    const hostname = url.hostname
    const hostnameParts = hostname.split('.')

    if (hostnameParts.length > 2) {
      const subdomain = hostnameParts.slice(0, -3).join('.')
      return subdomain
    } else {
      return null
    }
  } catch (error) {
    console.error('Invalid URL:', error)
    return null
  }
}

const NavItems = [
  {
    label: 'Things To Do',
    path: '/things-to-do/'
  },
  {
    label: 'Eat',
    path: '/eat-out/'
  },
  {
    label: 'Travel',
    path: '/travel/'
  },
  {
    label: 'Lifestyle',
    path: '/lifestyle/'
  },
  {
    label: 'Home',
    path: '/home/'
  }
]

const NewNav = () => {
  const [navState, setNavState] = useState<'collapsed' | 'full' | 'hidden'>(
    'full'
  )
  const [subD, setSubD] = useState<string | null>(null)

  useEffect(() => {
    headerEvents.on('headerState', state => {
      setNavState(state)
    })

    if (typeof window !== 'undefined') {
      const subdomain = getSubdomain(window.location.href)
      setSubD(subdomain)
    }
  }, [])

  return (
    <>
      <div className={navState !== 'full' ? NavStyles.CollapsedWrapper : ''}>
        <ul className={NavStyles.NewNavWrapper}>
          {NavItems.map((item, index) => {
            const url =
              subD && subD != null ? `/${subD}${item.path}` : item.path
            return (
              <li key={index}>
                <a href={url}>{item.label}</a>
              </li>
            )
          })}
        </ul>
        {navState !== 'full' && (
          <span className={NavStyles.SocialLinks}>
            <Social />
          </span>
        )}
      </div>
    </>
  )
}

export default NewNav
